export const Letter = ({ decoded }) => {
  const body = decoded ? "text-[#2a3d4e]" : "text-[#8b929c]";
  return (
    <div
      className={`relative w-full px-7 py-8 sm:px-9 sm:py-9 ${
        decoded ? "bg-[#FDF8EC]" : "bg-[#EDECE7]"
      }`}
      style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
    >
      <div className="flex items-start justify-between pb-4 border-b border-[#102333]/15">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#102333]" />
            <span className="font-display text-[11px] tracking-[0.25em] text-[#102333] font-medium">
              XYZ Insurance
            </span>
          </div>
          <span className="block mt-1 font-mono-file text-[9px] tracking-[0.2em] text-[#6A7883]">
            CLAIMS DIVISION · CORRESPONDENCE
          </span>
        </div>
        <span className="font-mono-file text-[10px] tracking-[0.15em] text-[#6A7883] text-right">
          CLAIM REF.
          <br />
          24-8817
        </span>
      </div>

      <p className={`mt-5 font-mono-file text-[10px] tracking-[0.15em] ${decoded ? "text-[#102333]" : "text-[#8b929c]"}`}>
        RE: DETERMINATION OF COVERAGE
      </p>

      <p className={`mt-4 text-[12.5px] sm:text-[13px] leading-relaxed ${body}`}>
        Dear Policyholder: We write in reference to the above-captioned matter and our ongoing
        evaluation of the circumstances surrounding the reported loss.
      </p>

      <div className="relative mt-4">
        <p className={`text-[12.5px] sm:text-[13px] leading-relaxed ${body}`}>
          Based upon our inspection and subject to all applicable limitations, conditions, and
          exclusions contained within the policy,{" "}
          <span
            className={
              decoded
                ? "bg-[#FFD166] shadow-[0_0_0_3px_#FFD166] text-[#102333]"
                : ""
            }
          >
            coverage cannot be afforded for the reported cause of loss at this time.
          </span>
        </p>
        {decoded && (
          <div className="absolute -right-1 -bottom-7 rotate-[-3deg] font-hand text-lg sm:text-xl text-[#8A2BE2] leading-none">
            they said no. make them show their work.
          </div>
        )}
      </div>

      <div className="relative mt-9">
        <p className={`text-[12.5px] sm:text-[13px] leading-relaxed ${body}`}>
          This correspondence is not intended as a waiver of any rights or defenses available under
          the policy, all of which are expressly reserved.
        </p>
        {decoded && (
          <div className="absolute -right-1 -bottom-6 rotate-[-2deg] font-hand text-lg text-[#8A2BE2] leading-none">
            translation: nothing is final. ask what happens next.
          </div>
        )}
      </div>

      <div className="mt-10 flex items-end justify-between">
        <div>
          <p className={`text-[12.5px] ${body}`}>Sincerely,</p>
          <p className={`text-[12.5px] italic ${body}`}>Claims Department</p>
        </div>
      </div>

      {decoded && (
        <>
          <div className="absolute bottom-6 right-7 rotate-[-9deg] border-2 border-[#8A2BE2] text-[#8A2BE2] px-3 py-1.5 font-display text-[11px] tracking-[0.3em]">
            FOG REMOVED
          </div>
          <div className="absolute bottom-4 left-7 sm:left-9 font-hand text-base sm:text-lg text-[#102333] rotate-[-1deg] max-w-[55%] leading-tight">
            43 words to say one thing. Ask three direct questions. <span className="text-[#8A2BE2] text-xl">J.</span>
          </div>
        </>
      )}

      {!decoded && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(160deg, rgba(255,255,255,0.55) 0%, rgba(230,230,225,0.25) 45%, rgba(255,255,255,0.5) 100%)",
          }}
        />
      )}
    </div>
  );
};

export default Letter;
